"use client";

import Link from "next/link";
import { usePathname, useRouter } from "next/navigation";
import { cn } from "./ui";

const ITEMS = [
  { href: "/studio", label: "Create", icon: "✨", exact: true },
  { href: "/studio/projects", label: "Projects", icon: "🎞️", exact: false },
  { href: "/studio/avatars", label: "Avatars", icon: "🧍", exact: false },
  { href: "/studio/analytics", label: "Analytics", icon: "📊", exact: false },
  { href: "/studio/billing", label: "Billing", icon: "💳", exact: false },
];

const SOON = [
  { label: "Assets", icon: "🗂️" },
  { label: "Inspiration", icon: "🔥" },
];

export function StudioNav() {
  const pathname = usePathname();
  const router = useRouter();

  return (
    <nav className="flex gap-1 overflow-x-auto px-4 pb-3 lg:flex-col lg:overflow-visible lg:pb-0">
      {ITEMS.map((it) => {
        const active = it.exact
          ? pathname === it.href
          : pathname.startsWith(it.href);
        return (
          <Link
            key={it.href}
            href={it.href}
            onClick={(event) => {
              if (pathname !== "/studio" || it.href === "/studio") return;
              event.preventDefault();
              const leave = new CustomEvent("easyshot:create-leave", {
                cancelable: true,
                detail: { href: it.href },
              });
              window.dispatchEvent(leave);
              if (!leave.defaultPrevented) router.push(it.href);
            }}
            className={cn(
              "flex items-center gap-2.5 rounded-xl px-3 py-2.5 text-sm whitespace-nowrap transition",
              active
                ? "bg-white/10 font-medium text-foreground"
                : "text-muted hover:bg-white/5 hover:text-foreground",
            )}
          >
            <span>{it.icon}</span>
            {it.label}
          </Link>
        );
      })}
      <div className="hidden lg:mt-4 lg:block lg:px-3 lg:pb-2 lg:text-[11px] lg:tracking-wide lg:text-white/25">
        Coming soon
      </div>
      {SOON.map((it) => (
        <span
          key={it.label}
          className="hidden cursor-not-allowed items-center gap-2.5 rounded-xl px-3 py-2.5 text-sm text-white/25 lg:flex"
        >
          <span>{it.icon}</span>
          {it.label}
        </span>
      ))}
    </nav>
  );
}
